import { trackAction } from 'app/shared/utils/tracking';

export const tracking = {
  render: () => {
    trackAction('sweepstakes_slide_in_displayed_on_desktop', {
      category: 'sweepstakes_slide_in',
      description: 'user views sweepstakes slide-in on desktop',
      label: 'sweepstakes_lp_entrypoint',
    });
  },
  closeIcon: () => {
    trackAction('slide_in_sweepstakes_closing_icon_clicked', {
      category: 'sweepstakes_slide_in',
      description:
        'user closes the slide-in sweepstakes by clicking on the closing icon',
      label: 'sweepstakes_lp_entrypoint',
    });
  },
  closeLink: () => {
    trackAction('slide_in_sweepstakes_closing_link_clicked', {
      category: 'sweepstakes_slide_in',
      description:
        'user closes the slide-in sweepstakes by clicking on the closing link',
      label: 'sweepstakes_lp_entrypoint',
    });
  },
  ctaClick: () => {
    trackAction('slide_in_sweepstakes_cta_clicked', {
      category: 'sweepstakes_slide_in',
      description:
        'user closes the slide-in sweepstakes by clicking on the cta',
      label: 'sweepstakes_lp_entrypoint',
    });
  },
};
